import go from 'gojs';

// Perform a TreeLayout where the node's actual tree-layer is specified by the "band" property on the node data.
function LayeredTreeLayout() {
    go.TreeLayout.call(this);

    this.treeStyle = go.TreeLayout.StyleLayered;  // required
    this.layerStyle = go.TreeLayout.LayerUniform;  // each layer goes completely across tree

    // don't move subtrees closer together, to maintain possible empty spaces between layers
    this.compaction = go.TreeLayout.CompactionNone;

    // sort a parent's child vertexes by the value of the index property
    function compareIndexes(v, w) {
        var vidx = v.index;
        if (vidx === undefined) vidx = 0;
        var widx = w.index;
        if (widx === undefined) widx = 0;
        return vidx - widx;
    }
    this.sorting = go.TreeLayout.SortingAscending;
    this.comparer = compareIndexes;

}
go.Diagram.inherit(LayeredTreeLayout, go.TreeLayout);

// Modify the standard LayoutNetwork by making children with the same "band" value as their
// parents actually be children of the grandparent.
LayeredTreeLayout.prototype.makeNetwork = function (coll) {
    var net = go.TreeLayout.prototype.makeNetwork.call(this, coll);
    // annotate every child with an index, used for sorting
    for (var it = net.vertexes.iterator; it.next();) {
        var parent = it.value;
        var idx = 0;
        for (var cit = parent.destinationVertexes; cit.next();) {
            cit.value.index = idx;
            idx += 10000;
        }
    }
    // now look for children with the same band value as their parent
    for (var it = net.vertexes.iterator; it.next();) {
        var parent = it.value;
        // Should this be recursively looking for grandchildren/greatgrandchildren that
        // have the same band as this parent node??  Assume that is NOT required.
        var parentband = parent.node.data.Level;
        var edges = [];
        for (var eit = parent.destinationEdges; eit.next();) {
            var edge = eit.value;
            var childband = edge.toVertex.node.data.Level;
            if (childband <= parentband) edges.push(edge);
        }
        // for each LayoutEdge that connects the parent vertex with a child vertex
        // whose node has the same band #, reconnect the edge with the parent's parent vertex
        var grandparent = parent.sourceVertexes.first();
        if (grandparent !== null) {
            var cidx = 1;
            for (var i = 0; i < edges.length; i++) {
                var e = edges[i];
                parent.deleteDestinationEdge(e);
                e.fromVertex = grandparent;
                grandparent.addDestinationEdge(e);
                e.toVertex.index = parent.index + cidx;
                cidx++;
            }
        }
    }
    return net;
};

LayeredTreeLayout.prototype.assignTreeVertexValues = function (v) {
    if (v.node.data) {
        v.level = v.node.data.Level;  // shift down to meet band requirement
    }
};

LayeredTreeLayout.prototype.commitLayers = function (layerRects, offset) {
    for (var it = this.network.vertexes.iterator; it.next();) {
        var v = it.value;

        // the band specifies the "layer" or "level" within the tree structure
        var pos = v.bounds.position;
        // this only works for angle === 0 or 90
        if (layerRects[v.level] != undefined) {
            if (this.angle === 0) {
                pos.x = layerRects[v.level].x;
            } else if (this.angle === 90) {
                pos.y = layerRects[v.level].y;
            }
            v.node.move(pos);
        }
    }
};

export { LayeredTreeLayout };

